import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("aimos_user") || "null"); } catch { return null; }
  });
  const [tenant, setTenant] = useState(() => {
    try { return JSON.parse(localStorage.getItem("aimos_tenant") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const persist = (token, u, t) => {
    localStorage.setItem("aimos_token", token);
    localStorage.setItem("aimos_user", JSON.stringify(u));
    localStorage.setItem("aimos_tenant", JSON.stringify(t));
    setUser(u); setTenant(t);
  };

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      persist(data.token, data.user, data.tenant);
      return data;
    } finally { setLoading(false); }
  };

  const signup = async (payload) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/signup", payload);
      persist(data.token, data.user, data.tenant);
      return data;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem("aimos_token");
    localStorage.removeItem("aimos_user");
    localStorage.removeItem("aimos_tenant");
    setUser(null); setTenant(null);
  };

  useEffect(() => {
    // refresh session
    if (localStorage.getItem("aimos_token")) {
      api.get("/auth/me").then(({ data }) => {
        if (data.user) { setUser(data.user); localStorage.setItem("aimos_user", JSON.stringify(data.user)); }
        if (data.tenant) { setTenant(data.tenant); localStorage.setItem("aimos_tenant", JSON.stringify(data.tenant)); }
      }).catch(() => {});
    }
  }, []);

  return (
    <AuthCtx.Provider value={{ user, tenant, loading, login, signup, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
